<template>
  <v-form v-model="formStatus.valid">
    <v-row>
      <v-col cols="12">
        <v-select
          filled
          :items="statuses"
          :rules="[rules.required]"
          label="Set status"
          v-model="dataToUpdate.status"
        >
        </v-select>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { textFieldRules } from '@/common'
import { constants } from '@/helpers'
export default {
  props: {
    dataToUpdate: {
      type: Object,
      required: true,
    },
    formStatus: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: textFieldRules,
      statuses: constants.STATUSES,
    }
  },
}
</script>